export const lerp = (current, target, amount = 0.2) =>
  (target - current) * amount
